import { InjectionToken } from "@angular/core";

// eslint-disable-next-line @tseslint/typedef
export const SORT_DIRECTIONS = {
  NO_SORT: "no-sort",
  ASCENDING: "asc",
  DESCENDING: "desc"
} as const;
export type SortDirection = typeof SORT_DIRECTIONS[keyof typeof SORT_DIRECTIONS];
// eslint-disable-next-line @tseslint/no-explicit-any, @tseslint/explicit-module-boundary-types
export function isSortDirection (value: any): value is SortDirection {
  return value === SORT_DIRECTIONS.ASCENDING || value === SORT_DIRECTIONS.DESCENDING;
}
export const DEFAULT_SORT_DIRECTION_ORDER: SortDirection[] = [ SORT_DIRECTIONS.NO_SORT, SORT_DIRECTIONS.ASCENDING, SORT_DIRECTIONS.DESCENDING ];
/**
 * Default sort direction used when no specific sort direction is provided.
 */
export const DEFAULT_SORT_DIRECTION: SortDirection = SORT_DIRECTIONS.NO_SORT;
/**
 * Injection token for configuring the sort direction order.
 */
export const SORT_DIRECTION_ORDER: InjectionToken<SortDirection[]> = new InjectionToken<SortDirection[]>("SortDirectionOrder");

